<template>
  <div class="bodyNews">
    <el-row :gutter="24">
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <div class="title">
          <h2>{{ navlist.title }}</h2>
        </div></el-col
      >
    </el-row>

    <el-row :gutter="24">
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <div class="title2">
          <p>作者：{{ navlist.author }}</p>
          <p>发布时间：{{ navlist.ReleaseTime }}</p>
        </div></el-col
      >
    </el-row>

    <el-row :gutter="24">
      <el-col :xs="2" :sm="2" :md="24" :lg="24" :xl="24">
        <div class="title2">
          <div class="content" v-html="navlist.content"></div></div
      ></el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      workTask: [],
      navlist: {
        title: "青歌传媒：工作不止公司和家的两点一线，还有说走就走的团建活动",
        author: "李焱婷 刘嘉灵",
        ReleaseTime: "2022-07-25 18:20:31",
        content: `<p style="text-indent: 2em; text-align: left;">
    城市无法给予的烟火气，工作无法给予的轻松悠闲，快节奏无法给予的缓慢，我们把这样的生活称之为向往的生活。
</p>
<p style="text-align:center">
    <img src="https://image.danews.cc/upload/doc/20220727/62e0e50cb3783.png" title="" alt=""/>
</p>
<p style="text-indent: 2em; text-align: left;">
    我们一共玩了3个拓展训练项目，上午玩的第一个拓展训练项目是信任手牵手蒙眼走路。顾名思义，这个项目的开展是建立在彼此信任的基础上。我们按照顺序依次手牵手并排，每位小伙伴们各自戴上眼罩通往动物乐园。刚戴上眼罩时，大家都很紧张，但走了一段路之后，大家所有的顾虑一消而散，相继完成了挑战。
</p>
<p style="text-align:center">
    <img src="https://image.danews.cc/upload/doc/20220727/62e0e61f96ca0.png" title="" alt=""/>
</p>
<p style="text-align:center">
    <img src="https://image.danews.cc/upload/doc/20220727/62e0e623f1919.png" title="" alt=""/>
</p>
<p style="text-align:center">
    <img src="https://image.danews.cc/upload/doc/20220727/62e0e62a2d668.png" title="" alt=""/>
</p>
<p style="text-indent: 2em; text-align: left;">
    短暂的游玩之旅结束，BBQ走起！
</p>
<p style="text-indent: 2em; text-align: left;">
    不远处，细腻的小伙伴们正在有条不紊地清洗着青菜、肉类等食材。
</p>
<p style="text-align:center">
    <img src="https://image.danews.cc/upload/doc/20220727/62e0e63b0483f.png" title="" alt=""/>
</p>
<p style="text-align:center">
    <img src="https://image.danews.cc/upload/doc/20220727/62e0e63ea23eb.png" title="" alt=""/>
</p>
<p style="text-indent: 2em; text-align: left;">
    靠近院墙的土锅，火被烧得旺旺的，我们小伙伴为大家呈现独家秘方的原生态炒鸡。
</p>
<p style="text-align:center">
    <img src="https://image.danews.cc/upload/doc/20220727/62e0e647391fe.png" title="" alt=""/>
</p>
<p style="text-align:center">
    <img src="https://image.danews.cc/upload/doc/20220727/62e0e64d536b9.png" title="" alt=""/>
</p>
<p style="text-indent: 2em; text-align: left;">
    丰富的食材，充足的饮料，专业的厨师，加上凉爽的天气和怡人的风景，Perfect!
</p>
<p style="text-align:center">
    <img src="https://image.danews.cc/upload/doc/20220727/62e0e6569beae.png" title="" alt=""/>
</p>
<p style="text-indent: 2em; text-align: left;">
    人生最幸福的事，就是大家通过齐心协力劳动之后，坐下来，开始分享彼此付出努力后的成果。之前采购回来的食材，经过小伙伴们的巧手，变成了美味的佳肴，这滋味，甜在嘴里，绵延至心房。
</p>
<p style="text-align:center">
    <img src="https://image.danews.cc/upload/doc/20220727/62e0e661029dd.png" title="" alt=""/>
</p>
<p style="text-align:center">
    <img src="https://image.danews.cc/upload/doc/20220727/62e0e66ce23c4.png" title="" alt=""/>
</p>
<p style="text-indent: 2em; text-align: left;">
    饱餐之余，当然是玩游戏啦！小伙伴们集思广益，团结协作完成了一幅幅画作。
</p>
<p style="text-align:center">
    <img src="https://image.danews.cc/upload/doc/20220727/62e0e6986fafd.png" title="" alt=""/>
</p>
<p style="text-align:center">
    <img src="https://image.danews.cc/upload/doc/20220727/62e0e691914e9.png" title="" alt=""/>
</p>
<p style="text-indent: 2em; text-align: left;">
    小伙伴们用巧手画的成品已经出来啦！是不是美美哒~
</p>
<p style="text-align:center">
    <img src="https://image.danews.cc/upload/doc/20220727/62e0e6a47c0f8.png" title="" alt=""/>
</p>
<p style="text-indent: 2em; text-align: left;">
    接下来最震撼全场的环节到啦，小伙伴们随着音乐的节奏高唱了一首《海阔天空》,送给梦想与自由。
</p>
<p style="text-indent: 2em; text-align: center;">
    <video width="550" height="auto" controls="">
        <source src="https://mpvideo.qpic.cn/0bc3d4aakaaapeaah2tjm5rfah6daupqabia.f10002.mp4?dis_k=b98f121e03a1434d82033342f52e4a8c&dis_t=1661235669&vid=wxv_2373268317009969153&format_id=10002&support_redirect=0&mmversion=false" type="video/mp4"/>
        <source src="movie.ogg" type="video/ogg"/>
    </video>
</p>
<p style="text-indent: 2em; text-align: left;">
    这次团建活动，对于我们的同事而言，更像是一次好友聚会。经过短暂的忙碌后，约定好了时间，进行了久违的相聚。
</p>
<p style="text-indent: 2em; text-align: left;">
    最后，希望青歌传媒的小伙伴们能相互协作，共同成长。
</p>`,
      },
    };
  },
  created() {
    this.workTask = this.$route.query.id;
    console.log(this.workTask);
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
.content {
  width: 60rem;
  margin: 5rem auto;
  color: #000000;
  ::v-deep {
    img {
      width: 100%;
    }
  }
}
.content {
  
}
.bodyNews {
  margin: 20px auto;
}
.bodyNews p {
  color: #aaa;
}
.title2 p {
  display: inline;
  padding-left: 15px;
  font-size: 16px;
}
.title h2 {
  color: #000000;
}
</style>



// WEBPACK FOOTER //
// src/components/secondpage.vue